import { useTranslation } from "react-i18next";

export default function TextComponent(props) {
    const {title, text, textString} = props
    const {t} = useTranslation();
    return (
        <div style={{ width: "100%" }}>
        {title&&<span className="titleClassName">{t(title)}</span>}
        {textString&&<span className="checkboxLabelClassName">{t(text)}</span>}
      </div>
    );
}